export default __webpack_public_path__ + "static/60-79e49cdee6a0c2528f77a5f439ad71e4.gif";